const convertirNumero = (valor) => {
  if (valor === null || valor === undefined || valor === "") return null;
  const numero = Number(valor);
  return Number.isFinite(numero) ? numero : null;
};

export const obtenerCantidadIngreso = (item = {}) => {
  const cantidad = [item.Unidades, item.nUnidades, item.Cantidad, item.nCantidad]
    .map(convertirNumero)
    .find((valor) => valor !== null);
  const peso = [item.Peso, item.nPeso]
    .map(convertirNumero)
    .find((valor) => valor !== null);

  if (cantidad !== null && cantidad !== undefined && (cantidad !== 0 || !peso)) {
    return cantidad;
  }

  return peso ?? cantidad ?? 0;
};

export const limpiarCantidadDeDescripcion = (descripcion) => String(descripcion ?? "")
  .replace(/\s*\(\s*-?\d+(?:[.,]\d+)?\s*\)\s*$/, "")
  .trim();
